import { useCallback } from "react";

import { ExternalSortManagement, SortStateDescriptor } from "components/Filters/types";
import useSortState from "components/Filters/useSortState";
import { getAriaSort, getSortIcon } from "ds/components/Table/Head/helpers";
import { SearchQueryOrderDirection } from "types/generated";

const useColumnSort = (
  columnSortKey: string,
  filtersStorageKey?: string,
  externalSortManagement?: ExternalSortManagement
) => {
  const {
    sortState: { sortDirection, sortKey },
    applySortState,
  } = useSortState(externalSortManagement);

  const isColumnSorted = sortKey === columnSortKey;

  const handleSort = useCallback(
    (callback?: (sortState: SortStateDescriptor) => void) => {
      const newSortState = {
        sortKey: columnSortKey,
        sortDirection:
          sortDirection === SearchQueryOrderDirection.Asc
            ? SearchQueryOrderDirection.Desc
            : SearchQueryOrderDirection.Asc,
      };

      if (filtersStorageKey) applySortState(newSortState, filtersStorageKey);
      callback?.(newSortState);
    },
    [applySortState, columnSortKey, filtersStorageKey, sortDirection]
  );

  return {
    handleSort,
    icon: getSortIcon(isColumnSorted ? sortDirection : undefined),
    ariaSort: getAriaSort(isColumnSorted ? sortDirection : undefined),
  };
};

export default useColumnSort;
